import { useEffect } from 'react';
import styled from 'styled-components';
import { useThumbnailManualReady } from '@elfsight/configurator-preview';
import { Deactivation2 as Deactivation } from '@elfsight/widget-deactivation';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../constants';
import { Title } from './common';
import { Files } from './Files';
import { getClassName } from './helpers';

export function Widget() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);
  const {
    width,
    backgroundColor,
    renderThumbnailMode,
    displayDeactivation,
    deactivationURL
  } = settings;

  // Ширина ошибочно выставляется второй раз, но оставляем чтоб не изменить внешний вид существующих виджетов
  const parsedWidth = (() => {
    if (width === 'auto') {
      return '100%';
    } else if (typeof width === 'number' || !width?.includes('%')) {
      return `${parseInt(width as string, 10)}px`;
    }

    return width;
  })();

  const [enableThumbnailReadyListener, resolveThumbnailReadyListener] =
    useThumbnailManualReady(renderThumbnailMode);

  useEffect(() => {
    enableThumbnailReadyListener();
  }, [enableThumbnailReadyListener]);

  return (
    <Deactivation
      appAlias={meta.alias}
      displayDeactivation={displayDeactivation}
      deactivationURL={deactivationURL}
    >
      <Container
        className={getClassName('widget', 'container')}
        _width={parsedWidth}
        _backgroundColor={backgroundColor}
        onLoad={() => resolveThumbnailReadyListener()} // Короткая запись onLoad={resolveThumbnailReadyListener} не работает по неустановленным причинам
      >
        <Title />

        <Files />

        <FreeLink
          {...freeLinkSettings}
          appAlias={meta.alias}
          appName={meta.name}
          style={{
            link: {
              marginTop: '20px'
            }
          }}
        />
      </Container>
    </Deactivation>
  );
}

const Container = styled.div<{
  _width: string;
  _backgroundColor?: string;
}>`
  display: block;
  box-sizing: border-box;
  min-width: 100px;
  width: 100%;
  position: relative;
  max-width: ${({ _width }) => _width};
  ${({ _backgroundColor }) =>
    _backgroundColor &&
    `
    background-color: ${_backgroundColor};
    ${_backgroundColor !== 'transparent' && 'padding: 40px'};
  `}
`;
